import { StorableObject } from "@app/core/storable-object";

export class CurrentCourse extends StorableObject  {
    public courseCode: string;
    public courseName: string;
}